// cosma
export const GRAY100 = '#ffffff';
export const GRAY200 = '#f5f5f5';
export const GRAY300 = '#eaeaea';
export const GRAY400 = '#e0e0e0';
export const GRAY500 = '#d6d6d6';
export const GRAY600 = '#cccccc';
export const GRAY700 = '#adadad';
export const GRAY800 = '#8f8f8f';
export const GRAY900 = '#606060';
export const GRAY1000 = '#333333'; /* Charcoal/Secondary color */
export const GRAY1100 = '#242424';
export const GRAY100_TRANSPARENT08 = '#ffffffEB';
export const GRAY100_TRANSPARENT16 = '#ffffffD6';
export const GRAY100_TRANSPARENT24 = '#ffffffC2';
export const GRAY100_TRANSPARENT32 = '#ffffffAD';
export const GRAY100_TRANSPARENT40 = '#ffffff99';
export const GRAY100_TRANSPARENT48 = '#ffffff85';
export const GRAY600_TRANSPARENT08 = '#ccccccEB';
export const GRAY600_TRANSPARENT16 = '#ccccccD6';
export const GRAY600_TRANSPARENT24 = '#ccccccC2';
export const GRAY600_TRANSPARENT32 = '#ccccccAD';
export const GRAY600_TRANSPARENT40 = '#cccccc99';
export const GRAY600_TRANSPARENT48 = '#cccccc85';
export const GREEN100 = '#ccffe2';
export const GREEN200 = '#96facf';
export const GREEN300 = '#60f0c1';
export const GREEN400 = '#38e2ba';
export const GREEN500 = '#00d0b2'; /* Success color */
export const GREEN600 = '#00b2a9';
export const GREEN700 = '#008f95';
export const GREEN800 = '#006878';
export const GREEN900 = '#004d63';
export const GREEN600_TRANSPARENT08 = '#00b2a9EB';
export const GREEN600_TRANSPARENT16 = '#00b2a9D6';
export const GREEN600_TRANSPARENT24 = '#00b2a9C2';
export const GREEN600_TRANSPARENT32 = '#00b2a9AD';
export const GREEN600_TRANSPARENT40 = '#00b2a999';
export const GREEN600_TRANSPARENT48 = '#00b2a985';
export const BLUE100 = '#d3ecff';
export const BLUE200 = '#a6d6ff';
export const BLUE300 = '#7abdff';
export const BLUE400 = '#59a5ff';
export const BLUE500 = '#237fff'; /* Info color */
export const BLUE600 = '#2267e8';
export const BLUE700 = '#1148b7';
export const BLUE800 = '#0b3293';
export const BLUE900 = '#06237a';
export const BLUE600_TRANSPARENT08 = '#2267e8EB';
export const BLUE600_TRANSPARENT16 = '#2267e8D6';
export const BLUE600_TRANSPARENT24 = '#2267e8C2';
export const BLUE600_TRANSPARENT32 = '#2267e8AD';
export const BLUE600_TRANSPARENT40 = '#2267e899';
export const BLUE600_TRANSPARENT48 = '#2267e885';
export const ORANGE100 = '#fef9d3';
export const ORANGE200 = '#fdf2a8';
export const ORANGE300 = '#fbe77c';
export const ORANGE400 = '#f7db5a';
export const ORANGE500 = '#f2ca26';
export const ORANGE600 = '#d0a91b';
export const ORANGE700 = '#ae8913';
export const ORANGE800 = '#8c6b0c';
export const ORANGE900 = '#745507';
export const ORANGE_TRANSPARENT08 = '#d0a91bEB';
export const ORANGE_TRANSPARENT16 = '#d0a91bD6';
export const ORANGE_TRANSPARENT24 = '#d0a91bC2';
export const ORANGE_TRANSPARENT32 = '#d0a91bAD';
export const ORANGE_TRANSPARENT40 = '#d0a91b99';
export const ORANGE_TRANSPARENT48 = '#d0a91b85';
export const RED100 = '#fde7d8';
export const RED200 = '#fccab1';
export const RED300 = '#f7a589';
export const RED400 = '#f0816b';
export const RED500 = '#e74b3c'; /* Alert/Error color */
export const RED600 = '#c62c2b';
export const RED700 = '#a61e28';
export const RED800 = '#851325';
export const RED900 = '#6e0b23';
export const RED_TRANSPARENT08 = '#c62c2bEB';
export const RED_TRANSPARENT16 = '#c62c2bD6';
export const RED_TRANSPARENT24 = '#c62c2bC2';
export const RED_TRANSPARENT32 = '#c62c2bAD';
export const RED_TRANSPARENT40 = '#c62c2b99';
export const RED_TRANSPARENT48 = '#c62c2b85';
export const TEAL50 = '#d9fff8';
export const TEAL100 = '#99ffec';
export const TEAL200 = '#00ffd0'; /* Primary color */
export const TEAL300 = '#00f2c6';
export const TEAL400 = '#00d9b1';
export const TEAL500 = '#00bf9c';
export const TEAL600 = '#00b392';
export const TEAL700 = '#00997d';
export const TEAL800 = '#008c72';
export const TEAL900 = '#00735e';

export const LIGHT_TEAL = '#e7fdf1';
export const TEAL_TRANSPARENT08 = '#00FFCBEB';
export const TEAL_TRANSPARENT16 = '#00FFCBD6';
export const TEAL_TRANSPARENT24 = '#00FFCBC2';
export const TEAL_TRANSPARENT32 = '#00FFCBAD';
export const TEAL_TRANSPARENT40 = '#00FFCB99';
export const TEAL_TRANSPARENT48 = '#00FFCB85';
export const CYAN50 = '#e0f7f8';
export const CYAN100 = '#b2ebee';
export const CYAN200 = '#80dee4';
export const CYAN300 = '#4dd0da';
export const CYAN400 = '#25c5d2';
export const CYAN500 = '#00bbcc';
export const CYAN600 = '#00abba';
export const CYAN700 = '#0096a0';
export const CYAN800 = '#008289';
export const CYAN900 = '#035f5f';
export const CYAN_TRANSPARENT08 = '#00bbccEB';
export const CYAN_TRANSPARENT16 = '#00bbccD6';
export const CYAN_TRANSPARENT24 = '#00bbccC2';
export const CYAN_TRANSPARENT32 = '#00bbccAD';
export const CYAN_TRANSPARENT40 = '#00bbcc99';
export const CYAN_TRANSPARENT48 = '#00bbcc85';

// frontify infographics
export const INFOGRAPHICS_DARK_ORANGE = '#E67E23';
export const INFOGRAPHICS_DARK_YELLOW = '#F2CA26';
export const INFOGRAPHICS_DARK_TEAL = '#00D0B2';
export const INFOGRAPHICS_DARK_BLUE = '#3598DB';
export const INFOGRAPHICS_CHARCOAL60 = '#676767';
export const INFOGRAPHICS_CHARCOAL20 = '#C4C4C4';
export const INFOGRAPHICS_CHARCOAL = '#333333';
export const INFOGRAPHICS_WHITE = '#FFFFFF';
export const INFOGRAPHICS_ALERT = '#E74B3C';

export const PRIMARY_COLOR = TEAL200;
export const SECONDARY_COLOR = GRAY1000;
